import * as React from 'react';
import { Projects as ProjectsComponent } from '../../components/Projects';
import { ViewModeSwitch } from '../../components/ViewModeSwitch';
import { Filters } from '../Filters';
import { ResidentialComplexesList } from '../ResidentialComplexesList';
import { Map } from '../Map';
import { TViewMode } from './types';

const contentComponent: Record<TViewMode, React.FC> = {
  tile: ResidentialComplexesList,
  map: Map,
};

export function Projects() {
  const [viewMode, setViewMode] = React.useState<TViewMode>('tile');
  const ContentComponent = React.useMemo(() => contentComponent[viewMode], [viewMode]);

  return (
    <ProjectsComponent
      filters={<Filters />}
      content={<ContentComponent />}
      switch={<ViewModeSwitch mode={viewMode} onModeChange={setViewMode} />}
    />
  );
}
